import React, { useRef, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import OTPInput from "otp-input-react";
import { enqueueSnackbar } from "notistack";
import { ClipLoader } from "react-spinners";
import { LSSB } from "../utils/LSSB_live";
import { InfoCircle, Verify } from "iconsax-react";
import Modal from "../component.js/Modal";

const ValidateOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [isApplSuccess, setIsApplySuccess] = useState(false);
  const userRef = useRef();

  async function validtaeOtp(e) {
    e.preventDefault();
    if (otp.length < 6) {
      enqueueSnackbar("Please enter a valid OTP", { variant: "error" });
      return;
    }

    setIsLoading(true);
    try {
      let res = await LSSB.make_API_call({
        _endpoint: "auth_user",
        auth_key: location?.state?.username || location?.state?.email,
        auth_action: "verify_email",
        otp: otp,
      });
      if (res?.success == true) {
        enqueueSnackbar(res?.data?.msg, { variant: "success" });
        // navigate("/login");
        setIsApplySuccess(true);
        setTimeout(() => {
          navigate("/login");
        }, 2000);
        setIsLoading(false);
      } else {
        enqueueSnackbar(res?.error?.msg, { variant: "error" });
        setIsLoading(false);
      }
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: "error" });

      setIsLoading(false);
    }
  }

  function hideEmail(email) {
    if (typeof email !== "string" || email.length < 6) {
      console.error("Invalid email address");
      return "";
    }

    // Extract the first character
    let hiddenEmail = email.charAt(0);

    // Replace characters from the second to the sixth with asterisks
    for (let i = 1; i < email.length; i++) {
      if (i >= 1 && i <= 5) {
        hiddenEmail += "*";
      } else {
        hiddenEmail += email.charAt(i);
      }
    }

    return hiddenEmail;
  }

  async function disableButton() {
    const button = document.getElementById("resendButton");
    const countdownDisplay = document.querySelector(".countdown");

    try {
      let res = await LSSB.make_API_call({
        _endpoint: "auth_user",
        email: location?.state?.email,
        auth_action: "resend_verify_email_otp",
      });

      if (res?.success == true) {
        enqueueSnackbar(res?.data?.msg, { variant: "success" });
        // navigate("/");
        setIsLoading(false);
      } else {
        enqueueSnackbar(res?.error?.msg, { variant: "error" });
        setIsLoading(false);
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
    // Disable the button
    button.disabled = true;

    // Set the countdown duration (in seconds)
    const countdownDuration = 1 * 60; // 5 minutes
    let remainingTime = countdownDuration;

    // Update the countdown display
    function updateCountdown() {
      const minutes = Math.floor(remainingTime / 60);
      const seconds = remainingTime % 60;

      countdownDisplay.textContent = `Time remaining: ${minutes}:${seconds}`;
    }

    // Update the countdown initially
    updateCountdown();

    // Update the countdown every second
    const countdownInterval = setInterval(function () {
      remainingTime--;

      // Update the countdown display
      updateCountdown();

      // Check if the countdown is complete
      if (remainingTime <= 0) {
        // Enable the button
        button.disabled = false;

        // Clear the countdown interval
        clearInterval(countdownInterval);

        // Reset the countdown display
        countdownDisplay.textContent = "";
      }
    }, 1000);
  }

  return (
    <div className="bg-[#F2F2F2] h-screen w-full flex flex-col justify-center items-center ">
      <div className="bg-[#ffff] rounded-[16px] w-[90%]  max-w-[628px] pt-[16px] md:pt-[32px]  pb-[24px] px-[16px] sm:px-[30px] md:px-[60px] xl:px-[80px]">
        <h3 className=" text-[20px] md:text-[28px] text-[#1a202c] text-center font-bold pb-1">
          Confirm Your Identity
        </h3>
        <p className="text-[#667185] text-md mb-5 w-[90%] mx-auto text-center">
          We have sent a verification code to your email
          {hideEmail(location?.state?.email)}
        </p>
        <div className="flex justify-center my-6">
          <OTPInput
            value={otp}
            className="border-[#000] "
            onChange={setOtp}
            autoFocus
            ref={userRef}
            OTPLength={6}
            otpType="number"
            disabled={false}
            secure
            inputStyles={{
              padding: "5px",
              backgroundColor: "#DBDCDDFF",
              border: "#000",
              borderRadius: "5px",
            }}
          />
        </div>

        <button
          type="button"
          onClick={validtaeOtp}
          className="w-full py-[14px] text-center text-white bg-[#AF8544] rounded-[8px] flex items-center justify-center mb-[20px] md:mb-[32px]"
        >
          <p className="text-sm font-medium leading-[20px]">Confirm</p>
          {isLoading && <ClipLoader color={"white"} size={20} />}
        </button>

        <p
          className="text-[#AF8544] countdown text-[14px]  text-center mt-4 "
          id="countdown"
        ></p>

        <div className="flex justify-between items-center w-full ">
          <div className="flex">
            <p className="text-[14px] font-semibold text-[#667185]">
              Didnt receive a verification code?
            </p>
          </div>{" "}
          <button
            id="resendButton"
            onClick={disableButton}
            className="text-[#AF8544] font-semibold"
          >
            Resend
          </button>
        </div>
      </div>
      <div className="p-2 py-3 mt-4 shadow  flex gap-1 mx-3">
        <InfoCircle
          color="#AF8544"
          variant="Bold"
          size={16}
          className="w-[20px]"
        />
        <p className="text-sm text-[#1a202c]  ">
          Please check your spam if you fail to see the OTP messages in your
          inbox.
        </p>
      </div>

      <Modal
        isOpen={isApplSuccess}
        onClose={() => {
          setIsApplySuccess(false);
        }}
      >
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[550px] ">
          <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg">
            <Verify color={"#AF8544"} size={48} className="mt-6 mx-auto mb-6" />
            <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[16px] md:mb-[20px] ">
              Account registered successfully!!{" "}
            </h2>
            <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F]   ">
              You can now login with your registered details and apply for
              awards.
            </p>
            <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F]   ">
              You will be redirected to the login page in 2 seconds.
            </p>
            <Link to="/login">
              <button className="w-full  py-[8px] md:py-[10px] bg-[#AF8544] text-center mt-6 md:mt-7">
                <p className="text-white text-md md:text-lg  ">
                  Proceed to login
                </p>
              </button>
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ValidateOtp;
